export const ROUTE_NAMES = {
  LOGIN: {
    name: 'login',
    path: '/login',
  },
  CHANGE_PASSWORD: {
    name: 'changePassword',
    path: '/change-password',
  },
  RECOVER_PASSWORD: {
    name: 'recover-password',
    path: '/recover-password',
  },
  NOT_FOUND: {
    name: 'not-found',
    path: '/:pathMatch(.*)*',
  },
  UNAUTHORIZED: {
    name: 'unauthorized',
    path: '/acceso-no-autorizado',
  },
  WELCOME: {
    path: '/home',
    HOME: {
      path: 'dashboard',
      name: 'welcome-home',
    },
  },
  ADMINISTRATION: {
    path: '/administration',
    USERS: {
      name: 'administration.users',
      path: 'users',
    },
    PERMISSION: {
      name: 'administration.permissions',
      path: '/permissions',
    },
    ROLES: {
      name: 'administration.roles',
      path: '/roles',
    },
    MODULES: {
      name: 'administration.modules',
      path: '/modules',
    },
  },
  MASTERS: {
    path: '/masters',
    WAREHOUSE: {
      name: 'masters.warehouse',
      path: 'warehouse',
    },
    UNITS: {
      name: 'masters.units',
      path: 'units',
    },
    ARTICLES: {
      name: 'masters.articles',
      path: 'articles',
      FORMS: {
        path: 'forms',
        name: 'articles.create',
      },
      UPDATE: {
        path: 'forms/:id',
        name: 'articles.update',
      },
    },
    RUBRO: {
      name: 'masters.rubros',
      path: 'rubros',
    },
    MOTIVOS: {
      name: 'masters.motivos',
      path: 'motivos',
    },
    FORMULAS: {
      name: 'masters.formulas',
      path: 'formulas',
      COMPONENTES: {
        name: 'masters.components',
        path: ':id/componentes',
      },
    },
  },
  PROCESS: {
    path: '/process',
    MATERIAPRIMA: {
      name: 'process.materiaprima',
      path: 'materiaP',
      FORMS: {
        path: 'ordenes-ingreso',
        name: 'materiaprima.create',
      },
      UPDATE: {
        path: 'forms/:id',
        name: 'materiaprima.update',
      },
      PRODUCTS: {
        path: ':id/productos-entrada',
        name: 'materiaprima.products',
      },
      SALIDA: {
        path: 'ordenes-salida',
        name: 'materiaprima.salida.create',
      },
      OUTPRODUCTS: {
        path: ':id/productos-salida',
        name: 'materiaprima.salida.products',
      },
      UPDATEMATERIA: {
        path: 'ordenes-salida/:id',
        name: 'materiaprima.salida.update',
      },
    },
    MATERIALEMPAQUE: {
      name: 'process.materialempaque',
      path: 'materialE',
      FORMS: {
        path: 'ordenes-ingreso',
        name: 'materialempaque.create',
      },
      UPDATE: {
        path: 'forms/:id',
        name: 'materialempaque.update',
      },
      PRODUCTS: {
        path: ':id/productos-entrada',
        name: 'materialempaque.products',
      },
      SALIDA: {
        path: 'ordenes-salida',
        name: 'materialempaque.salida.create',
      },
      OUTPRODUCTS: {
        path: ':id/productos-salida',
        name: 'materialempaque.salida.products',
      },
      UPDATEMATERIA: {
        path: 'ordenes-salida/:id',
        name: 'materialempaque.salida.update',
      },
    },
    MIXTURE: {
      name: 'process.mixture',
      path: 'mezclas',
      INHEADER: {
        path: 'ingreso-cabecera',
        name: 'mezclas.in.header',
      },
      INHEADERUPDATE: {
        path: 'ingreso-cabecera/:id',
        name: 'mezclas.in.header.update',
      },
      INDETAIL: {
        path: ':id/ingreso-detalle',
        name: 'mezclas.in.detail',
      },
      OUTHEADER: {
        path: 'salida-cabecera',
        name: 'mezclas.out.header',
      },
      OUTHEADERUPDATE: {
        path: 'salida-cabecera/:id',
        name: 'mezclas.out.header.update',
      },
      OUTDETAIL: {
        path: ':id/salida-detalle',
        name: 'mezclas.out.detail',
      },
      OUTDYNAMICDETAIL: {
        path: ':id/formula-generada',
        name: 'mezclas.out.dinamic.detail',
      },
    },
    LIQUIDS: {
      name: 'process.liquid',
      path: 'mezclasl',
      INHEADER: {
        path: 'ingreso-cabecera',
        name: 'liquid.in.header',
      },
      INHEADERUPDATE: {
        path: 'ingreso-cabecera/:id',
        name: 'liquid.in.header.update',
      },
      INDETAIL: {
        path: ':id/ingreso-detalle',
        name: 'liquid.in.detail',
      },
      OUTHEADER: {
        path: 'salida-cabecera',
        name: 'liquid.out.header',
      },
      OUTHEADERUPDATE: {
        path: 'salida-cabecera/:id',
        name: 'liquid.out.header.update',
      },
      OUTDETAIL: {
        path: ':id/salida-detalle',
        name: 'liquid.out.detail',
      },
      OUTDYNAMICDETAIL: {
        path: ':id/formula-generada',
        name: 'liquid.out.dinamic.detail',
      },
    },
    PACKAGING: {
      name: 'process.packaging',
      path: '/sachetado',
      INHEADER: {
        path: 'ingreso-cabecera',
        name: 'packaging.in.header',
      },
      OUTHEADER: {
        path: 'salida-cabecera',
        name: 'packaging.out.header',
      },
      OUTHEADERUPDATE: {
        path: 'salida-cabecera/:id',
        name: 'packaging.out.header.update',
      },
      INDETAIL: {
        path: ':id/ingreso-detalle',
        name: 'packaging.in.detail',
      },
      OUTDETAIL: {
        path: ':id/salida-detalle',
        name: 'packaging.out.detail',
      },
      INHEADERUPDATE: {
        path: 'ingreso-cabecera/:id',
        name: 'packaging.in.header.update',
      },
    },
    PRODUCT_FLOW: {
      name: 'process.productflow',
      path: '/empaquetado',
      INHEADER: {
        path: 'ingreso-cabecera',
        name: 'productflow.in.header',
      },
      OUTHEADER: {
        path: 'salida-cabecera',
        name: 'productflow.out.header',
      },
      OUTHEADERUPDATE: {
        path: 'salida-cabecera/:id',
        name: 'productflow.out.header.update',
      },
      INDETAIL: {
        path: ':id/ingreso-detalle',
        name: 'productflow.in.detail',
      },
      OUTDETAIL: {
        path: ':id/salida-detalle',
        name: 'productflow.out.detail',
      },
      INHEADERUPDATE: {
        path: 'ingreso-cabecera/:id',
        name: 'productflow.in.header.update',
      },
      OUTDETAILFORMULA: {
        path: ':id/formula',
        name: 'productflow.out.formula'
      }
    },
    FINAL_PRODUCT: {
      name: 'process.finalProduct',
      path: '/productot',
      INHEADER: {
        path: 'ingreso-cabecera',
        name: 'finalProduct.in.header',
      },
      OUTHEADER: {
        path: 'salida-cabecera',
        name: 'finalProduct.out.header',
      },
      OUTHEADERUPDATE: {
        path: 'salida-cabecera/:id',
        name: 'finalProduct.out.header.update',
      },
      INDETAIL: {
        path: ':id/ingreso-detalle',
        name: 'finalProduct.in.detail',
      },
      OUTDETAIL: {
        path: ':id/salida-detalle',
        name: 'finalProduct.out.detail',
      },
      INHEADERUPDATE: {
        path: 'ingreso-cabecera/:id',
        name: 'finalProduct.in.header.update',
      },
      OUTDETAILFORMULA: {
        path: ':id/formula',
        name: 'finalProduct.out.formula'
      }
    },
    QUALITY: {
      name: 'process.calidad',
      path: 'calidad',
      FORMS: {
        path: 'ordenes-ingreso',
        name: 'calidad.create',
      },
      UPDATE: {
        path: 'forms/:id',
        name: 'calidad.update',
      },
      PRODUCTS: {
        path: ':id/productos-entrada',
        name: 'calidad.products',
      },
      SALIDA: {
        path: 'ordenes-salida',
        name: 'calidad.salida.create',
      },
      OUTPRODUCTS: {
        path: ':id/productos-salida',
        name: 'calidad.salida.products',
      },
      UPDATEMATERIA: {
        path: 'ordenes-salida/:id',
        name: 'calidad.salida.update',
      },
    },
  },
  INTEGRATION: {
    name: 'integration',
    path: '/integration',
  },
  REPORTS: {
    name: 'reports',
    path: '/reports',
  }
};